export class GfaLayerManagerV1Impl {
    constructor(delegate) {
        this.delegate = delegate;
    }
    openAlert(render, state, options) {
        return this.delegate.openAlert(render, state, this.mapAlertOptions(options));
    }
    openFocusLayer(render, state, options) {
        return this.delegate.openFocusLayer(render, state, this.mapFocusOptions(options));
    }
    subscribe(listener) {
        return this.delegate.subscribe(listener);
    }
    mapAlertOptions(options) {
        if (!options) {
            return undefined;
        }
        const shimBackgroundType = this.mapShimBackGroundType(options.shimBackgroundType);
        return Object.assign(Object.assign({}, options), { shimBackgroundType });
    }
    mapFocusOptions(options) {
        const shimBackgroundType = this.mapShimBackGroundType(options.shimBackgroundType);
        const size = this.mapFocusLayerSize(options.size);
        return Object.assign(Object.assign({}, options), { shimBackgroundType,
            size });
    }
    mapShimBackGroundType(backgroundType) {
        if (!backgroundType) {
            return undefined;
        }
        switch (backgroundType) {
            case 'OPAQUE':
                return "OPAQUE" /* OPAQUE */;
            case 'TRANSPARENT':
                return "TRANSPARENT" /* TRANSPARENT */;
        }
    }
    mapFocusLayerSize(size) {
        switch (size) {
            case 'A':
                return "A" /* A */;
            case 'B':
                return "B" /* B */;
        }
    }
}
//# sourceMappingURL=gfa-layer-manager-v1-impl.js.map